import { TaskCustomFieldType } from "./TaskCustomFieldType";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { useQueryClient } from "@tanstack/react-query";
import { useUpdateTaskCustomField } from "../../data/mutations/taskCustomFieldMutations";

export const CustomFieldsContainer = ({
  taskCustomFields,
  customFieldGroup,
  taskId,
}) => {
  const { t } = useTranslation(["Overlay", "Shared"], {
    useSuspense: false,
  });

  const { mutate: updateTaskCustomField } = useUpdateTaskCustomField();
  const queryClient = useQueryClient();

  const ids = {
    customField: {
      textField: "custom-field-text",
      dateField: "custom-field-date",
      checkboxField: "custom-field-checkbox",
    },
  };

  const onTaskCustomFieldModified = (e) => {
    const taskCustomField = {
      ...e.value,
      TaskId: taskId,
    };

    updateTaskCustomField(
      { taskCustomField: taskCustomField },
      {
        onSuccess: () => {
          queryClient.invalidateQueries(["get-task", taskId]);
          toast.success(t("Success"), { position: "bottom-left" });
        },
        onError: () => {
          toast.error(t("ErrorMsg"), { position: "bottom-left" });
        },
      }
    );
  };

  return (
    <div className="custom-fields-container bc-bg-light-gray br-4">
      <div className="bg-et-lightest-gray bb-1-light-gray">
        <div className="py-2 px-3 fw-600 fs-14 et-black">
          {customFieldGroup?.Name}
        </div>
      </div>

      <div className="px-3 py-1">
        {customFieldGroup?.CustomFields?.map((customField, index) => (
          <div className="row align-items-center py-2" key={index}>
            <TaskCustomFieldType
              customField={customField}
              taskCustomField={taskCustomFields?.find(
                (x) => x.CustomFieldId === customField.Id
              )}
              onChange={onTaskCustomFieldModified}
              ids={ids}
            />
          </div>
        ))}
      </div>
    </div>
  );
};
